import React, { useContext, useMemo } from 'react';

import { cn, resultIf } from '../../../../utils';
import { SecondaryProjectContext } from '../../../../views/dashboard/lender/investment/purchase/SecondaryProjectContext/SecondaryProjectContext';
import SecondaryProjectNavigation from '../../../../views/dashboard/lender/investment/purchase/SecondaryProjectNavigation';
import { DetailedProjectContext } from '../DetailedProjectContext/DetailedProjectContext';
import DetailedProjectHtml from '../DetailedProjectHtml';
import DetailedProjectNavigation from '../DetailedProjectNavigation';
import { useMountAnimation, useWindowWidth } from '../hooks';
import ProjectDropdown from '../ProjectDropdown';

import './ProjectEconomicAnalysis.scoped.scss';

const ProjectEconomicAnalysis = () => {
  const project = useContext(DetailedProjectContext).project;
  const mounted = useMountAnimation();
  const isMobile = useWindowWidth();

  const debtorInfo = useMemo(() => {
    return (
      project.information !== null && (
        <div className={cn('project-economic', resultIf(mounted, 'mounted'))}>
          <DetailedProjectHtml translations={project.information.content} />
        </div>
      )
    );
  }, [mounted]);

  const offer = !!useContext(SecondaryProjectContext);
  const navigation = useMemo(() => {
    if (offer) {
      return <SecondaryProjectNavigation />;
    } else {
      return <DetailedProjectNavigation />;
    }
  }, [offer]);
  return (
    <div className="project-economic-container">
      {isMobile ? (
        <ProjectDropdown header="Экономический анализ">{debtorInfo}</ProjectDropdown>
      ) : (
        <>
          <div className="detailed-project__header">{navigation}</div>
          <div className="detailed-project__content">{debtorInfo}</div>
        </>
      )}
      <ProjectDropdown header="Бизнес должника">
        {project.information !== null && (
          <DetailedProjectHtml translations={project.information.businessContent} />
        )}
      </ProjectDropdown>
    </div>
  );
};

export default ProjectEconomicAnalysis;
